import { render, staticRenderFns } from "./AsideViewFacebookAd.vue?vue&type=template&id=7ec97998&scoped=true&"
import script from "./AsideViewFacebookAd.vue?vue&type=script&lang=js&"
export * from "./AsideViewFacebookAd.vue?vue&type=script&lang=js&"
import style0 from "./AsideViewFacebookAd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AsideViewFacebookAd.vue?vue&type=style&index=1&id=7ec97998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec97998",
  null
  
)

export default component.exports